import { render, staticRenderFns } from "./BsaAdjRvnTotal.vue?vue&type=template&id=196beb94"
import script from "./BsaAdjRvnTotal.vue?vue&type=script&lang=js"
export * from "./BsaAdjRvnTotal.vue?vue&type=script&lang=js"
import style0 from "./BsaAdjRvnTotal.vue?vue&type=style&index=0&id=196beb94&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('196beb94')) {
      api.createRecord('196beb94', component.options)
    } else {
      api.reload('196beb94', component.options)
    }
    module.hot.accept("./BsaAdjRvnTotal.vue?vue&type=template&id=196beb94", function () {
      api.rerender('196beb94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/bsa/BsaAdjRvnTotal.vue"
export default component.exports